import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { DaySetting } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import React, { useState } from 'react';
import { Icon } from 'src/common/components/icon';
import { ListItemType, ListView } from 'src/common/components/list-view';
import { useOpenModal } from 'src/common/components/next-modal';
import { Option } from '../option';
import { useModel } from 'src/common/create-model';
import { SettingProvider } from '../common';

interface Props {
  startDay: DaySetting;
  setStartDay: React.Dispatch<React.SetStateAction<DaySetting>>;
}
export const DateSetting: FC = () => {
  const { t } = useAppTranslation();
  const {
    spaceSettingState: { startDay, setStartDay },
  } = useModel(SettingProvider);
  const openModal = useOpenModal();

  const handleClick = (event: React.MouseEvent) => {
    openModal.dropdown({
      popcorn: event.currentTarget,
      placement: 'bottom',
      content: () => <DaySettingList startDay={startDay} setStartDay={setStartDay} />,
    });
  };

  return (
    <Option
      title={t('components.space_setting.date.title')}
      description={t('components.space_setting.date.description')}
      rightPart={
        <button className="text-t2 text-black flex items-center" onClick={handleClick}>
          {startDay === DaySetting.MON
            ? t('components.space_setting.date.monday')
            : t('components.space_setting.date.sunday')}
          <Icon name="IcArrowDown01" size="xxxsmall" className="ml-1" />
        </button>
      }
    />
  );
};

const DaySettingList: FC<Props> = ({ startDay, setStartDay }) => {
  const { t } = useAppTranslation();
  const [day, setDay] = useState(startDay);

  const items = [
    { type: DaySetting.MON, title: t('components.space_setting.date.monday') },
    { type: DaySetting.SUN, title: t('components.space_setting.date.sunday') },
  ].map((item) => ({
    type: ListItemType.OPERABLE_BLOCK_TEXT,
    data: { ...item, selected: item.type === day },
  }));

  return (
    <ListView
      className="rounded-r next-modal py-1.5 w-[120px]"
      items={items}
      onItemClick={(item) => {
        setDay(item.data.type);
        setStartDay(item.data.type);
      }}
    />
  );
};
